import {
  AiOutlineFile,
  AiOutlineFilePdf,
  AiOutlineFileExcel,
  AiOutlineFileWord
} from "react-icons/ai";

type Props = {
  extension: string;
};

const FileIcon: React.FC<Props> = ({ extension }) => {
  let icon;
  if (["xlsx", "xls"].includes(extension)) {
    icon = <AiOutlineFileExcel />;
  } else if (["pdf"].includes(extension)) {
    icon = <AiOutlineFilePdf />;
  } else if (["doc", "docx"].includes(extension)) {
    icon = <AiOutlineFileWord />;
  } else {
    icon = <AiOutlineFile />;
  }
  return icon;
};

export default FileIcon;
